import React, { useEffect, useState } from "react";
import {
  Button,
  Checkbox,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  TextField,
  Tabs,
  Tab,
  Box,
  IconButton
} from "@mui/material";
import { viewClaim } from "../utils/API";
import CloseIcon from "@mui/icons-material/Close";
import SelectComponent from "../components/core/SelectComponent";
import { getClaimEditData, updateClaim } from "../utils/API";
import EditIcon from "@mui/icons-material/Edit";
import get from "lodash.get";
import SelectComponent2 from "./core/SelectComponent2";
import { isVitrayaInternalUser } from "../constants/UserAuth";
import SelectComponent3 from "./core/SelectComponent3";
import VerticalTabs from "./viewClaim/ClaimDocument";
import ViewClaimShimmerEffect from "../components/core/ViewClaimShimmerEffect";
import ValidationRules from "./core/validationRules";
import axios from "axios";
import clonedeep from "lodash.clonedeep";
import {getSTPTableData} from "../utils/API";
import SelectComponent4 from "./core/SelectComponent4";

const EditClaim = (props) => {
  const {
    // procedureList,
    // roomList,
    treatmentList,
    selectedProcedure,
    selectedRoomType,
    hospitalId,
    selectedTreatmentType,
    selectedIllnessType,
    selectedsecondaryIllnessType,
    selectedtertiaryIllnessType,
    selectedUnDisclosedPedType,
    selectedUnDisclosedPedDuration,
    claimId,
    disabled,
    // reasonsForHospitalisation,
    selectedReasonForHospitalization,
    selectedPEDList,
    // pedList,
    documents,
    claimStatus = "",
    coverCode = "",
    claimPedList,
    gplavalue,
  } = props;

  // working
  const [loading, setLoading] = useState(false);
  const [procedureList, setProcedureList] = useState([]);
  const [pedList, setPedList] = useState([]);
  const [suggestedIllness, setSuggestedIllness] = useState([]);
  const [reasonsForHospitalisation, setReasonsForHospitalisation] = useState(
    [],
  );
  const [claimData, setClaimData] = useState([]);
  const [open, setOpen] = useState(false);
  const [roomType, setRoomType] = useState([]);
  const [selectedRoom, setSelectedRoom] = useState("");
  const [selectedProcedureId, setSelectedProcedureId] = useState("");
  const [selectedTreatment, setSelectedTreatment] = useState("");
  const [
    selectedReasonForHospitalisation,
    setSelectedReasonForHospitalisation,
  ] = useState("");
  const [selectedPED, setSelectedPED] = useState([]);
  const [selectedIllness, setSelectedIllness] = useState("");
  const [selectedFilename, setSelectedFilename] = useState("");
  const [summaryBillPages, setSummaryBillPages] = useState("");
  const [detailedBillPages, setDetailedBillPages] = useState("");
  const [detailedPageError, setDetailedPageError] = useState(false);
  const [summaryPageError, setSummaryPageError] = useState(false);
  const [comorbidity, setComorbidity] = useState(false);
  const [comorbidIllness, setComorbidIllness] = useState([]);
  const [secondaryIllness, setSecondaryIllness] = useState("");
  const [tertiaryIllness, setTertiaryIllness] = useState("");
  const [undisclosedIllness, setUndisclosedIllness] = useState("");
  const [errorClaim, setErrorClaim] = useState("");
  const [tabValue, setTabValue] = useState(0);
  const [preAuthRules, setPreAuthRules] = useState([]);
  const [validationRules, setValidationRules] = useState([]);
  // const [comorbidIllnessesList, setComorbidIllnessesList] = useState([]);
//   const PED_STORAGE_KEY = "PED_ILLNESS_LIST";
  const [documentspdf, setDocuments] = useState([]);
  const fetchClaimEditData = async (hospitalid, claimid) => {
    const metaData = await getClaimEditData(hospitalid, claimid);
    setProcedureList(metaData.data["procedureList"]);
    setReasonsForHospitalisation(
      metaData.data["medicalEventList"].map((event) => event.name),
    );
   
    const illnessList = metaData?.data?.["illnessList"] || [];
    setPedList(metaData?.data?.["illnessList"] || []);
    setSuggestedIllness(metaData?.data?.["suggestionillnessList"] || [])
    setRoomType(metaData.data["hospitalServiceList"]);
    // const illnessList = metaData?.data?.["illnessList"] || [];  
    const illnessObject = get(
      illnessList.filter((item) => get(item, ["id"]) === selectedIllnessType),
      [0],
      null,
    );
    if (illnessObject !== null) {
      setSelectedIllness(illnessObject);
    }
    const secondaryillnessObject = get(
      illnessList.filter(
        (item) => get(item, ["id"]) === selectedsecondaryIllnessType,
      ),
      [0],
      null,
    );
    if (secondaryillnessObject !== null) {
      setSecondaryIllness(secondaryillnessObject);
    }
    const tertiaryillnessObject = get(
      illnessList.filter(
        (item) => get(item, ["id"]) === selectedtertiaryIllnessType,
      ),
      [0],
      null,
    );
    if (tertiaryillnessObject !== null) {
      setTertiaryIllness(tertiaryillnessObject);
    }
    const unDiclosedPedObject = get(
        illnessList.filter(
            (item) => get(item, ["id"]) === selectedUnDisclosedPedType,
        ),
        [0],
        null,
    );
    if (unDiclosedPedObject !== null) {
      setUndisclosedIllness(unDiclosedPedObject);
    }

    if (selectedUnDisclosedPedDuration !== null) {
      try {
        const parsed = JSON.parse(selectedUnDisclosedPedDuration);

        const newDuration = {
          year: parsed?.year || 0,
          month: parsed?.month || 0,
          week: parsed?.week || 0,
          day: parsed?.day || 0,
        };

        setDuration(newDuration);


      } catch (e) {
        console.log("Invalid JSON", e);
      }
    }

    if (gplavalue !== null) {
      try {
        const parsed = JSON.parse(gplavalue);

        const newgpla = {
          g: parsed?.g ?? null,
          p: parsed?.p ?? null,
          l: parsed?.l ?? null,
          a: parsed?.a ?? null,
        };

        setGpla(newgpla);
      } catch (e) {
        console.log("Invalid JSON", e);
        setGpla({
          g: null,
          p: null,
          l: null,
          a: null,
        });
      }
    } else {
      setGpla({
        g: null,
        p: null,
        l: null,
        a: null,
      });
    }

    setValidationRules(metaData.data["preAuthFormResults"] || [])

    return metaData;
  };

 
  

  const handleClickOpen = () => {
    fetchClaimEditData(hospitalId, claimId);
    setOpen(true);
    // let roomType = roomList?.filter((val) => val.hospitalId === hospitalId);
    // setRoomType(roomType);
    setSelectedRoom(selectedRoomType);
    setSelectedProcedureId(selectedProcedure.id);
    setSelectedTreatment(selectedTreatmentType);
    setSelectedReasonForHospitalisation(selectedReasonForHospitalization);
    setSelectedPED(selectedPEDList);
    fetchData();
    // getSTPTableData(claimId).then(data =>  setValidationRules(data.data["preAuthFormResults"] || []));
  };

  const fetchData = async () => {
    setLoading(true);
    try {
      // Fetch claim data first
      const fetchDataResult = await viewClaim(claimId);

      if (fetchDataResult?.success === false) {
        setErrorClaim(fetchDataResult?.message?.text);
        setLoading(false);
        return; // Exit early if claim fetch fails
      }
      // Set claim data
      setClaimData(clonedeep(fetchDataResult));

      // Fetch documents using the fetched claim data
      await getClaimDocuments(fetchDataResult);
    } catch (error) {
      console.error("Error fetching claim data:", error);
      setErrorClaim(error.message);
    } finally {
      setLoading(false);
    }
  };

  const getClaimDocuments = async (currentClaimData) => {
    // Use parameter if provided, otherwise use state
    const dataToUse = currentClaimData || claimData;

    // Guard clause - don't fetch if no claim data
    if (!dataToUse) {
      console.warn("No claim data available for fetching documents");
      return;
    }

    try {
      const response = await axios({
        url: `/document/list/${claimId}`,
        baseURL: `${process.env.REACT_APP_BACKEND_URL}/api/su/support`,
        method: "GET",
        headers: {
          "X-Client-Platform": "CLAIM-ENHANCEMENT",
          "Content-Type": "blob",
          "X-Auth-Token": `${localStorage.getItem("authToken")}`,
        },
      });

      let tempDocuments = get(response, ["data"], []).filter((item) => {
        if (
          ["DISCHARGE", "DISCHARGE_QUERY"].includes(get(item, ["stage"], ""))
        ) {
          return true;
        } else if (dataToUse?.coverCode === "DCTT") {
          if (
            [
              "PRE_AUTHORISATION_RAISED",
              "PRE_AUTHORISATION_RESPONSE_SENT",
            ].includes(dataToUse?.claimStatus) &&
            ["PRE_AUTH", "PRE_AUTH_QUERY"].includes(get(item, ["stage"], ""))
          ) {
            return true;
          } else if (
            ["INTERIM_RAISED", "INTERIM_RESPONSE_SENT"].includes(
              dataToUse?.claimStatus,
            ) &&
            ["INTERIM", "INTERIM_QUERY"].includes(get(item, ["stage"], ""))
          ) {
            return true;
          }
        }
        return false;
      });

      tempDocuments.push({
        fileName: "No Bill File",
        preSingedURL: "",
        dateCreated: "",
        stage: "DISCHARGE",
      });
      setDocuments(tempDocuments);
    } catch (error) {
      console.error("Error fetching documents:", error.message);
    }
  };

  const handleClose = () => {
    setOpen(false);
  };
  const handleProcedureChange = (id) => {
    // `0` is a valid procedure id, so guard on empty/null instead of truthiness
    if (id === "" || id === null || id === undefined) return;
    setSelectedProcedureId(id);
  };
  const handleRoomTypeChange = (roomType) =>
    roomType && setSelectedRoom(roomType);
  const handleTreatmentChange = (treatment) =>
    treatment && setSelectedTreatment(treatment);
  const handleReasonForHospitalisation = (reasonForHospitalisation) =>
    reasonForHospitalisation &&
    setSelectedReasonForHospitalisation(reasonForHospitalisation);
  // const handlePED = (ped) =>
  //     ped && setSelectedPED(ped);
  const handlePED = (ped) => {
    if (!Array.isArray(ped)) return;

    setSelectedPED(
      ped.map((item) => {
        const value = item.illnessName || "";
        const lastDashIndex = value.lastIndexOf("-");

        return {
          ...item,
          illnessName:
            lastDashIndex !== -1 ? value.slice(0, lastDashIndex) : value,
          icdCode:
            lastDashIndex !== -1
              ? value.slice(lastDashIndex + 1).split(":")[0]
              : "",
        };
      }),
    );
  };

  const handleFilename = (filename) =>
    filename && setSelectedFilename(filename);
  const handleComorbidIllness = (illness) => setComorbidIllness(illness);

  const handleIllness = (illness) => {
    if (illness) {
      setSelectedIllness(illness);
    }
  };

  const handleSecondaryIllness = (illness) => {
    if (illness) {
      setSecondaryIllness(illness);
    }
  };

  const handleTertiaryIllness = (illness) => {
    if (illness) {
      setTertiaryIllness(illness);
    }
  };
  const handleUndisclosedIllness = (illness) => {
    if (illness) {
      setUndisclosedIllness(illness);
    }
  };
  const [enableEditSubmit, setEnableEditSubmit] = useState(true);
  useEffect(() => {
    if (
      selectedIllness === "" ||
      selectedIllness.id === 0 ||
      selectedIllness.id === -1 ||
      selectedProcedureId === "" ||
      selectedProcedureId === -1 ||
      selectedProcedureId === null
    ) {
      setEnableEditSubmit(true);
    } else if (detailedPageError) {
      setEnableEditSubmit(true);
    } else if (summaryPageError) {
      setEnableEditSubmit(true);
    } else {
      setEnableEditSubmit(false);
    }
    setPedList((prevPedList) =>
      prevPedList.map((item) => {
        const optionLabel = item.id;
        return {
          ...item,
          active:
            optionLabel !== selectedIllness.id &&
            optionLabel !== secondaryIllness.id &&
            optionLabel !== tertiaryIllness.id, // disable current tertiary selection
        };
      }),
    );
  }, [
    selectedProcedureId,
    selectedIllness,
    detailedPageError,
    summaryPageError,
    secondaryIllness,
    tertiaryIllness,
  ]);

 

  const update = async (markFinal = false) => {
    if (isGplaLMissing) return;
    // console.log("checkComorbid IllnessUpdated", comorbidIllness);
    const data = {
      claimDataId: claimId,
      procedureId: parseInt(selectedProcedureId),
      roomType: selectedRoom,
      treatmentType: selectedTreatment,
      reasonForHospitalization: selectedReasonForHospitalisation,
      pedList: (selectedPED || []).map((item) => ({
        illnessName: item["illnessName"],
        icdCode: item["icdCode"],
      })),
      preAuthRules: preAuthRules,
      // pedList: (selectedPED || []).map(item => {
      //     const [illnessName, icdCode] = item.illnessName.split(/[-:]/);
      //
      //     return {
      //         illnessName,
      //         icdCode
      //     };
      // }),

      illnessId: selectedIllness?.id || -1,
      secondaryIllnessId: secondaryIllness?.id || -1,
      tertiaryIllnessId: tertiaryIllness?.id || -1,
      unDisclosedPEDId: undisclosedIllness?.id || -1,
      comorbidCase: comorbidity,
      comorbidCaseIllnesses: comorbidity
        ? (comorbidIllness || []).map((item) => parseInt(item.id, 10))
        : [],
      //illnessId: pedList.filter(item => `${get(item, ['illnessName'])} - ${get(item, ['defaultICDCode'])}` === selectedIllness)[0]['id'] || -1,
      markFinal: markFinal,
      segregationDetails: {
        filename: selectedFilename,
        summary_bill_pages: processPagesRange(summaryBillPages),
        detailed_bill_pages: processPagesRange(detailedBillPages),
      },
      unDisclosePEDuration:duration,
      gpla:gpla,
    };
    // console.log("final api data",data);

    // This function returns an Array of numbers
    function processPagesRange(input) {
      if (input.trim().length === 0) {
        return [];
      }
      const ranges = input.split(",");
      const output = [];
      ranges.forEach((range) => {
        range = range.replace(/[^0-9-]/g, "");
        const [start, end] = range.split("-").map(Number);
        if (!end) {
          output.push(start);
        } else {
          for (let i = start; i <= end; i++) {
            output.push(i);
          }
        }
      });
      if (output[0] === 0) {
        return [];
      }
      return output;
    }

    const response = await updateClaim(data);
    if (response) {
      setOpen(false);
    }
  };



  const showFileEditOptions = () => {
    if (
      [
        "DISCHARGE_RAISED",
        "DISCHARGE_RESPONSE_SENT",
        "QUERY_FOR_DISCHARGE",
      ].includes(claimStatus)
    ) {
      return true;
    } else if (coverCode === "DCTT") {
      if (
        [
          "PRE_AUTHORISATION_RAISED",
          "PRE_AUTHORISATION_RESPONSE_SENT",
        ].includes(claimStatus)
      ) {
        return true;
      } else if (
        ["INTERIM_RAISED", "INTERIM_RESPONSE_SENT"].includes(claimStatus)
      ) {
        return true;
      }
    }
    return false;
  };
  const isValidPageInput = (input) => {
    if (!input) return true;

    // Only digits, comma and hyphen
    if (!/^[0-9,-]*$/.test(input)) {
      return false;
    }

    const ranges = input.split(",");

    for (let range of ranges) {
      if (!range) continue;

      const parts = range.split("-");

      // ❌ More than one hyphen
      if (parts.length > 2) return false;

      const start = parts[0];
      const end = parts[1];

      // ❌ Start number > 3 digits
      if (start && start.length > 3) return false;

      // ❌ End number > 3 digits (if present)
      if (end && end.length > 3) return false;

      // ❌ "-" only is invalid
      if (!start && !end) return false;

      // ❌ Range order validation (only if both exist)
      if (start && end && Number(start) > Number(end)) {
        return false;
      }
    }

    return true;
  };
  const getSelectedIllnessLabel = (selectedIllness) => {
    if (!selectedIllness) return "";

    const illness = pedList.find((item) => item.id === selectedIllness.id);
    if (!illness) return "";

    return `${illness.illnessName}`;
  };

  // Handle toggle for validation rule approval
  const handleToggleApproval = (index) => {
    setValidationRules((prevRules) =>
      prevRules.map((rule, i) =>
        i === index ? { ...rule, approved: !rule.approved } : rule
      )
    );
  };

  // Handle submit validation rules
  const handleSubmitValidationRules = () => {
    const updatedRules = validationRules.map((rule) => ({
      ...rule,
      status: rule.approved ? "PASS" : "QUERY",
    }));
    console.log("Submitting validation rules:", updatedRules);
    // You can add API call here to submit the rules
    alert("Validation rules submitted successfully!");
  };

  const handleDateChange = (data) => {
     setPreAuthRules(data);
  };

  const [duration, setDuration] = useState({
    year: 0,
    month: 0,
    week: 0,
    day: 0,
  });

  const [gpla, setGpla] = useState({
    g: null,
    p: null,
    l: null,
    a: null,
  });

  // GPLA "L" is mandatory for delivery / maternity cases
  const normalizeText = (text) => String(text || "").trim().toLowerCase();
  const selectedProcedureName =
    get(
      (procedureList || []).find(
        (item) => String(item?.id) === String(selectedProcedureId),
      ),
      ["name"],
    ) || get(selectedProcedure, ["name"], "");
  const isGplaLMandatory =
    ["normal delivery", "c-section"].includes(
      normalizeText(selectedProcedureName),
    ) || normalizeText(selectedReasonForHospitalisation) === "maternity case";
  const isGplaLMissing =
    isGplaLMandatory && (gpla.l === null || gpla.l === undefined || gpla.l === "");

  const handleChange = (field, value) => {
    // Allow only digits
    const numericValue = value.replace(/\D/g, "");

    setDuration((prev) => ({
      ...prev,
      [field]: numericValue === "" ? 0 : parseInt(numericValue, 10),
    }));
  };



  const handleGPLAChange = (field, value) => {
    // Allow only digits
    const numericValue = value.replace(/\D/g, "");

    setGpla((prev) => ({
      ...prev,
      [field]: numericValue === "" ? null : parseInt(numericValue, 10),
    }));
  };




  // Prevent e,+,-,. in number fields
  const preventInvalidKeys = (e) => {
    if (["e", "E", "+", "-", "."].includes(e.key)) {
      e.preventDefault();
    }
  };

  return (
    <div>
      <Button
        variant="contained"
        color="primary"
        onClick={handleClickOpen}
        sx={{ textAlign: "center" }}
        endIcon={<EditIcon />}
        disabled={disabled}
      >
        Edit
      </Button>
      <Dialog
        open={open}
        onClose={handleClose}
        //scroll={'paper'}
        maxWidth={"x-lg"}
        fullWidth
        PaperProps={{
          style: {
            width: "98%",
            height: "98%",
            maxWidth: "98%",
            maxHeight: "98%",
          },
        }}
      >
        <Grid
          container
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItem: "space-between",
          }}
        >
          <Grid item>
            <DialogTitle sx={{ textAlign: "center" }}> Edit Claim </DialogTitle>
          </Grid>
          <Grid
            item
            onClick={handleClose}
            style={{ cursor: "pointer", padding: 10 }}
          >
            <CloseIcon />
          </Grid>
        </Grid>

        <DialogContent sx={{ padding: 0, height: "100%", overflow: "hidden" }}>
          <Grid container sx={{ height: "100%", overflow: "hidden" }}>
            {/* Left Side - PDF Viewer (Always Visible) */}
            <Grid
              item
              xs={12}
              md={6}
              sx={{
                height: "100%",
                borderRight: "1px solid #ddd",
                display: "flex",
                flexDirection: "column",
                backgroundColor: "#f5f5f5",
              }}
            >
              <Grid
                sx={{
                  padding: 2,
                  borderBottom: "1px solid #ddd",
                  backgroundColor: "#fff",
                  fontWeight: "bold",
                  fontSize: "16px",
                }}
              >
                Document Viewer
              </Grid>
              <Grid sx={{ flex: 1, overflow: "hidden", display: "flex" }}>
                {documentspdf && documentspdf.length > 0 ? (
                  <VerticalTabs id={claimId} files={documentspdf} />
                ) : (
                  <Grid
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "100%",
                      height: "100%",
                      color: "#888",
                      fontSize: "14px",
                    }}
                  >
                    No documents available for this claim
                  </Grid>
                )}
              </Grid>
            </Grid>

            {/* Right Side - Tabbed Content */}
            <Grid
              item
              xs={12}
              md={6}
              sx={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
              }}
            >
              {/* Tabs Section */}
              <Box
                sx={{
                  borderBottom: 1,
                  borderColor: "divider",
                  backgroundColor: "#fff",
                }}
              >
                <Tabs
                  value={tabValue}
                  onChange={(e, newValue) => setTabValue(newValue)}
                  sx={{ px: 2 }}
                >
                  <Tab label="Claim Details" />
                  <Tab label="Validation Rules" />
                </Tabs>
              </Box>

              {/* Tab Content Container */}
              <Box sx={{ flex: 1, overflow: "auto" }}>
                {/* Claim Details Tab */}
                <Box sx={{ display: tabValue === 0 ? "block" : "none" }}>
                  <Container sx={{ padding: 3 }}>
                    <Grid
                      container
                      spacing={2}
                    >
                      <Grid item xs={12} md={6}>
                        <p
                          style={{
                            fontSize: "16px",
                            fontWeight: 500,
                            marginBottom: "8px",
                          }}
                        >
                          Procedure :
                        </p>
                        <SelectComponent3
                          label={""}
                          menuItem={procedureList}
                          procedureName={selectedProcedure.name}
                          value={selectedProcedureId}
                          setSelections={(type) => handleProcedureChange(type)}
                          style={{ margin: 0 }}
                        />
                      </Grid>

                      <Grid item xs={12} md={6}>
                        <p
                          style={{
                            fontSize: "16px",
                            fontWeight: 500,
                            marginBottom: "8px",
                          }}
                        >
                          Room Type :
                        </p>
                        <SelectComponent3
                          label={""}
                          procedureName={selectedRoomType}
                          value={selectedRoom}
                          menuItem={roomType}
                          setSelections={(type) => handleRoomTypeChange(type)}
                          style={{ margin: 0 }}
                        />
                      </Grid>

                      <Grid item xs={12} md={6}>
                        <p
                          style={{
                            fontSize: "16px",
                            fontWeight: 500,
                            marginBottom: "8px",
                          }}
                        >
                          Treatment Type :
                        </p>
                        <SelectComponent
                          label={""}
                          procedureName={selectedTreatmentType}
                          menuItem={treatmentList}
                          setSelections={(type) => handleTreatmentChange(type)}
                          style={{ margin: 0 }}
                        />
                      </Grid>

                      <Grid item xs={12} md={6}>
                        <p
                          style={{
                            fontSize: "16px",
                            fontWeight: 500,
                            marginBottom: "8px",
                          }}
                        >
                          Reason for Hospitalisation :
                        </p>
                        <SelectComponent
                          label={""}
                          procedureName={selectedReasonForHospitalisation}
                          menuItem={reasonsForHospitalisation}
                          setSelections={(type) =>
                            handleReasonForHospitalisation(type)
                          }
                          style={{ margin: 0 }}
                        />
                      </Grid>

                      <Grid item xs={12} md={6}>
                        <p
                          style={{
                            fontSize: "16px",
                            fontWeight: 500,
                            marginBottom: "8px",
                          }}
                        >
                          Pre Existing Diseases :
                        </p>
                        <SelectComponent2
                          label={""}
                          procedureName={getSelectedIllnessLabel(selectedPED)}
                          menuItem={pedList}
                          setSelections={(type) => handlePED(type)}
                          multiple
                          style={{ margin: 0 }}
                        />
                        {claimPedList.length > 0 && (
                          <p style={{ fontSize: "14px", color: "#666", marginTop: "8px" }}>
                            PED ICD Codes :{" "}
                            {claimPedList.map((f) => f.icdCode).join(" | ")}
                          </p>
                        )}
                      </Grid>

                      <Grid item xs={12} md={6}>
                        <p
                          style={{
                            fontSize: "16px",
                            fontWeight: 500,
                            marginBottom: "8px",
                          }}
                        >
                          Illness :
                        </p>
                        <SelectComponent2
                          label={""}
                          procedureName={getSelectedIllnessLabel(
                            selectedIllness,
                          )}
                          menuItem={pedList}
                          // suggestionillnessList={suggestedIllness}
                          setSelections={(type) => handleIllness(type)}
                          style={{ margin: 0 }}
                        />
                      </Grid>

                      <Grid item xs={12} md={6}>
                        <p
                          style={{
                            fontSize: "16px",
                            fontWeight: 500,
                            marginBottom: "8px",
                          }}
                        >
                          Secondary Illness :
                        </p>
                        <SelectComponent2
                          label={""}
                          procedureName={getSelectedIllnessLabel(
                            secondaryIllness,
                          )}
                          menuItem={pedList}
                          setSelections={(type) => handleSecondaryIllness(type)}
                          style={{ margin: 0 }}
                        />
                      </Grid>

                      <Grid item xs={12} md={6}>
                        <p
                          style={{
                            fontSize: "16px",
                            fontWeight: 500,
                            marginBottom: "8px",
                          }}
                        >
                          Tertiary Illness :
                        </p>
                        <SelectComponent2
                          label={""}
                          procedureName={getSelectedIllnessLabel(
                            tertiaryIllness,
                          )}
                          menuItem={pedList}
                          setSelections={(type) => handleTertiaryIllness(type)}
                          style={{ margin: 0 }}
                        />
                      </Grid>

                      <Grid item xs={12} md={6}>
                        <p
                            style={{
                              fontSize: "16px",
                              fontWeight: 500,
                              marginBottom: "8px",
                            }}
                        >
                          Un-Disclosed PED :
                        </p>
                        <SelectComponent2
                            label={""}
                            procedureName={getSelectedIllnessLabel(
                                undisclosedIllness,
                            )}
                            menuItem={pedList}
                            setSelections={(type) => handleUndisclosedIllness(type)}
                            style={{ margin: 0 }}
                            disabledoption={false}
                        />
                      </Grid>

                      <Grid item xs={12} md={6}>
                        <p
                            style={{
                              fontSize: "16px",
                              fontWeight: 500,
                              marginBottom: "8px",
                            }}
                        >
                          Un-Disclosed PED Duration:
                        </p>
                        <Box>
                          <Box
                              sx={{
                                display: "flex",
                                gap: 1,
                                border: "1px solid #d1d5db",
                                borderRadius: 2,
                                p: 1,
                              }}
                          >
                            <TextField
                                label="Day"
                                size="small"
                                value={duration.day || ""}
                                onChange={(e) => handleChange("day", e.target.value)}
                                onKeyDown={preventInvalidKeys}
                                inputProps={{
                                  inputMode: "numeric",
                                  pattern: "[0-9]*",
                                }}
                            />

                            <TextField
                                label="Week"
                                size="small"
                                value={duration.week || ""}
                                onChange={(e) => handleChange("week", e.target.value)}
                                onKeyDown={preventInvalidKeys}
                                inputProps={{
                                  inputMode: "numeric",
                                  pattern: "[0-9]*",
                                }}
                            />

                            <TextField
                                label="Month"
                                size="small"
                                value={duration.month || ""}
                                onChange={(e) => handleChange("month", e.target.value)}
                                onKeyDown={preventInvalidKeys}
                                inputProps={{
                                  inputMode: "numeric",
                                  pattern: "[0-9]*",
                                }}
                            />

                            <TextField
                                label="Year"
                                size="small"
                                value={duration.year || ""}
                                onChange={(e) => handleChange("year", e.target.value)}
                                onKeyDown={preventInvalidKeys}
                                inputProps={{
                                  inputMode: "numeric",
                                  pattern: "[0-9]*",
                                }}
                            />
                          </Box>

                          {/*                    <pre>*/}
                          {/*  {JSON.stringify(duration, null, 2)}*/}
                          {/*</pre>*/}
                        </Box>

                        {/*<div style={{ marginTop: 10 }}>*/}
                        {/*   {duration.day}: Day*/}
                        {/*  {duration.month}: Month*/}
                        {/*   {duration.week}: Week*/}
                        {/*  {duration.year}: Year*/}
                        {/*</div>*/}
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <p
                            style={{
                              fontSize: "16px",
                              fontWeight: 500,
                              marginBottom: "8px",
                            }}
                        >
                          G.P.L.A :
                        </p>
                        <Box>
                          <Box
                              sx={{
                                display: "flex",
                                gap: 1,
                                border: "1px solid #d1d5db",
                                borderRadius: 2,
                                p: 1,
                              }}
                          >
                            <TextField
                                label="G"
                                size="small"
                                value={gpla.g ?? ""}
                                onChange={(e) => handleGPLAChange("g", e.target.value)}
                                onKeyDown={preventInvalidKeys}
                                inputProps={{
                                  inputMode: "numeric",
                                  pattern: "[0-9]*",
                                }}
                            />

                            <TextField
                                label="P"
                                size="small"
                                value={gpla.p ?? ""}
                                onChange={(e) => handleGPLAChange("p", e.target.value)}
                                onKeyDown={preventInvalidKeys}
                                inputProps={{
                                  inputMode: "numeric",
                                  pattern: "[0-9]*",
                                }}
                            />

                            <TextField
                                label="L"
                                size="small"
                                required={isGplaLMandatory}
                                error={isGplaLMissing}
                                helperText={isGplaLMissing ? "L is required" : ""}
                                value={gpla.l ?? ""}
                                onChange={(e) => handleGPLAChange("l", e.target.value)}
                                onKeyDown={preventInvalidKeys}
                                inputProps={{
                                  inputMode: "numeric",
                                  pattern: "[0-9]*",
                                }}
                            />

                            <TextField
                                label="A"
                                size="small"
                                value={gpla.a ?? ""}
                                onChange={(e) => handleGPLAChange("a", e.target.value)}
                                onKeyDown={preventInvalidKeys}
                                inputProps={{
                                  inputMode: "numeric",
                                  pattern: "[0-9]*",
                                }}
                            />
                          </Box>

                          {/*                    <pre>*/}
                          {/*  {JSON.stringify(duration, null, 2)}*/}
                          {/*</pre>*/}
                        </Box>

                        {/*<div style={{ marginTop: 10 }}>*/}
                        {/*   {duration.day}: Day*/}
                        {/*  {duration.month}: Month*/}
                        {/*   {duration.week}: Week*/}
                        {/*  {duration.year}: Year*/}
                        {/*</div>*/}
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <p
                          style={{
                            fontSize: "16px",
                            fontWeight: 500,
                            marginBottom: "8px",
                          }}
                        >
                          Comorbidity:
                        </p>
                        <Grid
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                          }}
                        >
                          <Checkbox
                            checked={comorbidity}
                            onChange={(e) => setComorbidity(!comorbidity)}
                            variant="standard"
                          />
                          <p style={{ fontSize: "16px", marginLeft: "0.5em" }}>
                            {comorbidity ? "Comorbid" : "Non-Comorbid"}
                          </p>
                        </Grid>
                      </Grid>

                      {comorbidity && (
                        <Grid item xs={12} md={6}>
                          <p
                            style={{
                              fontSize: "16px",
                              fontWeight: 500,
                              marginBottom: "8px",
                            }}
                          >
                            Comorbid Diseases :
                          </p>
                          <SelectComponent2
                            label={""}
                            procedureName={getSelectedIllnessLabel(
                              comorbidIllness,
                            )}
                            menuItem={pedList}
                            setSelections={(type) =>
                              handleComorbidIllness(type)
                            }
                            multiple
                            style={{ margin: 0 }}
                          />
                        </Grid>
                      )}

                      {showFileEditOptions() && (
                        <>
                          <Grid item xs={12} md={6}>
                            <p
                              style={{
                                fontSize: "16px",
                                fontWeight: 500,
                                marginBottom: "8px",
                              }}
                            >
                              Bill Filename :
                            </p>
                            <SelectComponent
                              label={""}
                              procedureName={selectedFilename}
                              menuItem={documents}
                              setSelections={(type) => handleFilename(type)}
                              style={{ margin: 0 }}
                            />
                          </Grid>

                          <Grid item xs={12} md={6}>
                            <p
                              style={{
                                fontSize: "16px",
                                fontWeight: 500,
                                marginBottom: "8px",
                              }}
                            >
                              Detailed Bill Pages:
                            </p>
                            <TextField
                              value={detailedBillPages}
                              onChange={(e) => {
                                const value = e.target.value;
                                setDetailedBillPages(value);
                                setDetailedPageError(!isValidPageInput(value));
                              }}
                              fullWidth
                              variant="outlined"
                              size="small"
                              error={detailedPageError}
                              helperText={
                                detailedPageError
                                  ? "Invalid page details (only numbers, max 3 digits)"
                                  : ""
                              }
                              inputProps={{
                                inputMode: "numeric",
                                pattern: "[0-9,-]*",
                              }}
                            />
                          </Grid>

                          <Grid item xs={12} md={6}>
                            <p
                              style={{
                                fontSize: "16px",
                                fontWeight: 500,
                                marginBottom: "8px",
                              }}
                            >
                              Summary Bill Pages:
                            </p>
                            <TextField
                              value={summaryBillPages}
                              onChange={(e) => {
                                const value = e.target.value;
                                setSummaryBillPages(value);
                                setSummaryPageError(!isValidPageInput(value));
                              }}
                              fullWidth
                              variant="outlined"
                              size="small"
                              error={summaryPageError}
                              helperText={
                                summaryPageError
                                  ? "Invalid page details (only numbers, max 3 digits)"
                                  : ""
                              }
                              inputProps={{
                                inputMode: "numeric",
                                pattern: "[0-9,-]*",
                              }}
                            />
                          </Grid>
                        </>
                      )}
                      
                      {errorClaim !== "" && (
                        <Grid item xs={12}>
                          <Container
                            maxWidth="xl"
                            style={{ textAlign: "center", padding: 40 }}
                          >
                            <p style={{ color: "red" }}>{errorClaim}</p>
                          </Container>
                        </Grid>
                      )}
                      {loading === true && (
                        <Grid item xs={12}>
                          <ViewClaimShimmerEffect />
                        </Grid>
                      )}
                    </Grid>
                  </Container>
                </Box>

                {/* Validation Rules Tab */}
                <Box sx={{ display: tabValue === 1 ? "block" : "none" }}>
                  <ValidationRules
                    validationRules={validationRules}
                    onToggleApproval={handleToggleApproval}
                    onSubmitRules={handleSubmitValidationRules}
                    onDateChange={handleDateChange}
                    disabled={false}
                    showSubmitButton={true}
                  />
                </Box>
              </Box>
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions>
          {/* {
            isVitrayaInternalUser(l) && <Button variant="contained" onClick={() => update()}>
              Edit
            </Button>
          } */}
          {isVitrayaInternalUser() && (
            <Button
              variant="contained"
              onClick={() => update(true)}
              disabled={enableEditSubmit || isGplaLMissing}
            >
              Edit and Mark Complete
            </Button>
          )}
          {!isVitrayaInternalUser() && (
            <Button
              variant="contained"
              onClick={() => update()}
              disabled={isGplaLMissing}
            >
              Confirm
            </Button>
          )}
          <Button variant="contained" onClick={handleClose} color="error">
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};
// under-review
export default EditClaim;
